import classNames from "classnames";
import md5 from "md5";
import qs from "query-string";
import React from "react";
import { Helmet } from "react-helmet";
import { Redirect, withRouter } from "react-router";
import { Button, Form, Input, InputGroup, Panel } from "rsuite";
import InputGroupAddon from "rsuite/esm/InputGroup/InputGroupAddon";
import InputGroupButton from "rsuite/esm/InputGroup/InputGroupButton";
import Logo from "../assets/logo.png";
import { AuthContext } from "../components/authProvider/main";
import { ConfirmModal } from "../components/modal/main";
import { ParametersGlobals } from "../core/parametersGlobals/ParametersGlobals";
import { LoginAnimationSvg } from "../svg/LoginAnimationSvg";
import axios from "../utilities/axios";
// import ResetPassword from "./ResetPassword";
// import AlterPassword from "../components/password/NewPasswordComponent";

class LoginPage extends React.Component<any, {}> {
  static contextType = AuthContext;
  public state = {
    isPasswordVisible: false,
    isLoading: false,
    userEmail: "",
    userPassword: "",
    errorMessage: null,
    firstAccess: false,
    resetPassword: false,
    messagePassword: "",
    userId: 0,
    token: "",
    showModal: false
  };

  handleChange = (value: string) => {
    this.setState({ userEmail: value })
  };

  doLogin = () => {
    this.setState({ isLoading: true, errorMessage: null });

    axios
      .post("/api/v1/auth", {
        user_email: this.state.userEmail.trim(),
        user_password: md5(this.state.userPassword),
      })
      .then((res) => {
        if (res && res.data && res.data.token) {
          (this.context as any).setAuth(res.data.token);
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status !== 200) {
          if (err.response.data.firstAccess) {
            console.log(err.response.data.firstAccess)
            this.setState({ token: err.response.data.token })
            this.setState({ messagePassword: "Primeiro Acesso" })
            this.setState({ firstAccess: true, userId: Number(err.response.data.userId), showModal: true });
          } else if (err.response.data.resetPassword) {
            this.setState({ token: err.response.data.token })
            this.setState({ messagePassword: "Redefinição de Senha" });
            this.setState({ resetPassword: true, userId: Number(err.response.data.userId), showModal: true })
          } else {
            this.setState({ errorMessage: err.response.data.message });
          }
        }
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
    // this.props.history.push('/')
  };

  handlePasswordSuccess = () => {
    this.setState({ firstAccess: false });
    this.setState({ resetPassword: false });
    this.setState({ showModal: false });
    this.setState({ isLoading: false });

    (this.context as any).setAuth(this.state.token);
    <Redirect to="/dashboard" />;

  };

  render() {
    if ((this.context as any).isAuthenticated) {
      return <Redirect to="/dashboard" />;
    }
    var { isAuthDone, failedToConnect } = qs.parse(this.props.location.search);
    if (isAuthDone) {
      localStorage.removeItem("currentCompany");
    }

    return (
      <div className="login-page">
        <Helmet>
          <title>{`${ParametersGlobals.projectTitle}`} - Login</title>
        </Helmet>
        <LoginAnimationSvg />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <ConfirmModal show={isAuthDone || failedToConnect}>
            {isAuthDone
              ? "Sua sessão encerrou!!! Faça o Login Novamente!"
              : "Houve uma falha na conexão com o servidor!"}
          </ConfirmModal>
          <Panel
            style={{
              width: "300px",
              padding: "20px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              backgroundColor: "#f9f9f9",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
            }}
          >
            <div style={{ margin: "0 auto 20px" }}>
              <img alt={"Logo"} src={Logo} style={{ width: "100px", borderRadius: "5px" }} />
            </div>
            <form onSubmit={() => this.doLogin()}>
              <Form.Group className="mb-4">
                <Form.ControlLabel>E-Mail</Form.ControlLabel>
                <InputGroup>
                  <InputGroupAddon>
                    <i className="fas fa-user"></i>
                  </InputGroupAddon>
                  <Input
                    value={this.state.userEmail}
                    onPressEnter={this.doLogin}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group className="mb-6">
                <Form.ControlLabel>Senha</Form.ControlLabel>
                <InputGroup>
                  <InputGroupAddon>
                    <i className="fas fa-lock"></i>
                  </InputGroupAddon>
                  <Input
                    value={this.state.userPassword}
                    onPressEnter={this.doLogin}
                    onChange={(v) => this.setState({ userPassword: v })}
                    type={this.state.isPasswordVisible ? "text" : "password"}
                  />
                  <InputGroupButton
                    onClick={() =>
                      this.setState({
                        isPasswordVisible: !this.state.isPasswordVisible,
                      })
                    }
                  >
                    <i
                      className={classNames(
                        "fas fa-fw",
                        "fa-" +
                        (!this.state.isPasswordVisible ? "eye" : "low-vision")
                      )}
                    ></i>
                  </InputGroupButton>
                </InputGroup>
              </Form.Group>
              {/* Botão e outros componentes */}
            </form>

            <div style={{ position: "relative", width: "100%" }}>
              <small
                style={{ position: "absolute", top: "-10px", color: "red" }}
              >
                {this.state.errorMessage}
              </small>
              <Button
                style={{
                  background: "#181368",
                  width: "100%",
                  marginTop: "5px",
                  fontSize: "16px",
                  border: "none",
                  borderRadius: "3px",
                  cursor: "pointer",
                  padding: "10px",
                  color: "white",
                }}
                color="green"
                onClick={this.doLogin}
                loading={this.state.isLoading}
              >
                Login
              </Button>
              <a href="/resetpassword">Esqueci Minha Senha</a>
            </div>
          </Panel>
        </div>

        {/* Modal para inserir nova senha */}
        {/* {(this.state.firstAccess || this.state.resetPassword) && (
          <AlterPassword
            message={this.state.messagePassword}
            show={this.state.firstAccess || this.state.resetPassword}
            onSuccess={this.handlePasswordSuccess}
            userId={this.state.userId}
            userEmail={this.state.userEmail}
            onClose={() => this.setState({ showModal: false })}

          />
        )} */}

      </div>
    );
  }
}

export default withRouter(LoginPage);
